
$( document ).ready(function() {
    $(".navbar-toggler").click(function(){
        $(".collapse").slideToggle();
         });

$(".dropdown-toggle").click(function(){
    $(this).parent().toggleClass("activenav");
});
     
$('.acc-container .acc:nth-child(1) .acc-head').addClass('active');
$('.acc-container .acc:nth-child(1) .acc-content').slideDown();
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.acc-content').slideUp();
    $(this).removeClass('active');
    }
    else {
    $('.acc-content').slideUp();
    $('.acc-head').removeClass('active');
    $(this).siblings('.acc-content').slideToggle();
    $(this).toggleClass('active');
    }
});  

$('.upslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow:1,
    speed: 5000,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
        {
            breakpoint:993,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:1.1,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          }        
      
      
      ]
});
$('.brandslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow:5,
    speed: 5000,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
        {
            breakpoint:993,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:2.3,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          }        
      
      
      ]
});



    // vars
  var slider, btn, tabC, prevIndex, objTab = {};
  
  btn = $(".btnn");
  tabC = $(".tabContent");
  
  prevIndex = 0;
  
  btn.on("click", function() {
    
    var th, thIndex;
    
    th = $(this);
    thIndex = th.index();
       
    if(!th.hasClass("active")) {
      if(prevIndex != thIndex && prevIndex !== 'undefined') {
        btn.eq(prevIndex).removeClass("active");
        tabC.eq(prevIndex).removeClass("show");
      }
      btn.eq(thIndex).addClass("active");
      tabC.eq(thIndex).addClass("show");
      prevIndex = thIndex;
      
      //slick position filter
      //if you have problem with slick in tabs, use next option
      //magic option
      tabC.eq(thIndex).find(".bestsellerslider").slick('setPosition');
    }
  });
  
  slider = $(".bestsellerslider");



$('.bestsellerslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:5,
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
        {
            breakpoint:1200,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
               arrows: false,
              
            }
          },
        {
            breakpoint:992,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              arrows: false,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              arrows: false,
               //centerMode:true,
            }
          }      
      
      
      ]
    
});

$('.bestsellersliderr').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:5,
    slidesToScroll:1,
    autoplay: true,
    prevArrow: $(".slideleftbtns"),
    nextArrow: $(".sliderightbtns"),
    // centerMode:true,
    responsive: [
        {
            breakpoint:1200,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
               arrows: false,
              
            }
          },
        {
            breakpoint:992,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              arrows: false,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              arrows: true,
               //centerMode:true,
            }
          }      
      
      
      ]
    
});

$('.textslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow:4,
    speed: 5000,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
          {
            breakpoint:1281,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          },
        {
            breakpoint:993,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:1.1,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          }        
      
      
      ]
});

$('.testimonialslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:5,
    slidesToScroll:1,
    autoplay: false,
        prevArrow: $(".slideleftbtn"),
    nextArrow: $(".sliderightbtn"),
    //centerMode:true,

    responsive: [
        {
            breakpoint:1201,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
             
            }
          },  
           {
            breakpoint:1200,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
             
            }
          }, 
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
             centerMode:true,
            }
          }     
      
      
      ]
    
    
  });

  $('.mainimage').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight:true,
    asNavFor: '.thumbimage'
  });
  $('.thumbimage').slick({
    slidesToShow:4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.mainimage',
    dots: false,
    //centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
      breakpoint:1200,
      settings: {
        slidesToShow:4,
        slidesToScroll:1,
        infinite: true,
        dots: false,
      }
      }        
    ]
  }); 

  $(document).on('click', '.prdqnt .btnqty', function(){
  var qty = parseInt($(this).parent('.prdqnt').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
   
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.prdqnt').find('.quantity-input').attr("value",qty);
});

$(document).on("click", ".stylevar1 input", function () {
      var color = $(this).val(); 
    $(this).parent().parent().find("li").removeClass("active");
    $(this).parent().addClass("active");
    var size = $(".impedencevariant .active input").val();

    if( typeof size == 'undefined'){
      var data = color; 
    } else {
      var data = size + " / " + color; 
    }
    console.log(data);
       
    $(".no-js > option").each(function() {
      if ($(this).text() == data){
        var v_img = $(this).attr("data-val"); 
        var id = $(this).val();
        var pr = $(this).attr("data-pr");
        var cpr = $(this).attr("data-com");
        var inv = $(this).attr("data-inv"); 
        $(".nwprice").text(pr);
        $(".oldprice").text(cpr);
        
        
    $(".formval").attr("value",id);
        /*$( ".thumb" ).each(function() {
      var a = $( this ).attr( "datav" );
      if(a == v_img){
        
        var b = $( this ).parent().parent().attr("data-slick-index");
        $('.thumbimage').slick('slickGoTo', b);
        
      }
    });*/
        
      }
    });
  });

});	

   






   

   